import { getSupportedDevicesSync } from "@eweadn-qiankun/shared-utils";
import { ensureCrossBrandBootstrap } from "@/crossBrandHub/store/bootstrapStore";
import { runCrossBrandScan } from "@/crossBrandHub/runScan";
import { shouldExpandHidPickerToAllBrands } from "@/crossBrandHub/utils/hidPickerScope";

/** 将 supportedDevices 同步给桌面端主进程（默认品牌 Hub 异品牌开启时含全品牌 VID/PID） */
export function registerDesktopBrandHidDevices(): boolean {
  const bridge = (
    window as { electronBridge?: { sendToElectron?: (msg: unknown) => void } }
  ).electronBridge;
  if (!bridge?.sendToElectron) {
    return false;
  }
  try {
    const includeCrossBrandHid = shouldExpandHidPickerToAllBrands();
    bridge.sendToElectron({
      type: "register-brand-hid-devices",
      data: {
        devices: getSupportedDevicesSync(),
        includeCrossBrandHid,
      },
    });
    return true;
  } catch (e) {
    console.warn("[DesktopBrandHid] 上报设备表失败:", e);
    return false;
  }
}

async function registerAfterBootstrap(): Promise<void> {
  await ensureCrossBrandBootstrap(true);
  registerDesktopBrandHidDevices();
}

/** 监听桌面端 request / 白名单 ack，补发设备表并在就绪后扫描异品牌 */
export function installDesktopBrandHidDevicesListener(): () => void {
  const bridge = (
    window as {
      electronBridge?: {
        onElectronMessage?: (
          cb: (type: string, data: unknown) => void
        ) => () => void;
      };
    }
  ).electronBridge;
  if (!bridge?.onElectronMessage) {
    return () => {};
  }
  return bridge.onElectronMessage((type, data) => {
    if (type === "request-brand-hid-devices") {
      void registerAfterBootstrap();
      return;
    }
    if (type === "register-brand-hid-devices-ack") {
      const payload = data as { ok?: boolean; count?: number } | undefined;
      if (payload?.ok) {
        void runCrossBrandScan("startup");
      }
    }
  });
}
